import { useState, useEffect } from "react";
import { Input, Table, Space, DatePicker, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useRequest } from "ahooks";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { useAuthContext } from "@/components/auth/AuthProvider";
import DepartmentTypeSelect from "@/components/common/DepartmentTypeSelect";
import DepartmentSelect from "@/components/common/DepartmentSelect";
import {
  message as messageService,
  setting as settingService,
} from "@/services";
import ReportTypeSelect from "../ReceiveMessage/ReportTypeSelect";
import ReportSwitch from "../ReceiveMessage/ReportSwitch";
import PublicationSelect from "../ReceiveMessage/PublicationSelect";
import OpinionSwitch from "../ReceiveMessage/OpinionSwitch";
import DeductPointSelect from "../ReceiveMessage/DeductPointSelect";
import ExportToTxt from "./ExportToTxt";
import styles from "./index.module.less";

function Status4MessageTable() {
  const [version, setVersion] = useState(Date.now());
  const [code, setCode] = useState();
  const [department, setDepartment] = useState();
  const [type, setType] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [keyword, setKeyword] = useState();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const { statusType } = useParams();
  const auth = useAuthContext();
  const { data: types = { results: [] }, loading: messageTypeLoading } =
    useRequest(() => settingService.listMessageType({}, auth.token), {
      ready: !!auth.token,
      refreshDeps: [auth.token],
    });
  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return messageService.listMyReceiveMessage(params, token);
    },
    {
      manual: true,
      throttleWait: 600,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          version,
          status: statusType,
          type,
          start_date: startDate,
          end_date: endDate,
          search: keyword,
          page,
          page_size: pageSize,
          department_type: code,
          department,
        },
        auth.token
      );
    }
  }, [
    run,
    keyword,
    page,
    pageSize,
    auth,
    statusType,
    code,
    department,
    type,
    startDate,
    endDate,
    version,
  ]);

  const columns = [
    {
      title: "序号",
      key: "num",
      width: 50,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "类型",
      key: "messageType",
      width: 80,
      render: (record) => record.type.name,
    },
    {
      title: "上报单位",
      key: "department",
      width: 100,
      ellipsis: true,
      render: (record) => record.sender.name,
    },
    {
      title: "标题",
      dataIndex: "title",
      render: (text, record) => (
        <Link to={`/workshop/mrece/detail/${record.id}`} target="_blank">
          {text}
        </Link>
      ),
    },
    {
      title: "日期",
      width: 140,
      dataIndex: "published_at",
      render: (text, record) => moment(text).format("YYYY-MM-DD HH:mm"),
    },
    {
      title: "状态",
      dataIndex: "status_name",
      width: 60,
    },
    {
      title: "采用类型",
      key: "reportType",
      width: 80,
      render: (record) => (
        <ReportTypeSelect
          messageId={record.id}
          defaultValue={record.report_type?.id}
          callback={setVersion}
        />
      ),
    },
    {
      title: "刊物名称",
      key: "publication",
      width: 100,
      render: (record) => (
        <PublicationSelect
          messageId={record.id}
          defaultValue={record.publication?.id}
          callback={setVersion}
        />
      ),
    },
    {
      title: "省级批示",
      key: "provincial_opinion",
      width: 80,
      render: (record) => (
        <OpinionSwitch
          messageId={record.id}
          field="provincial_opinion"
          defaultValue={record.provincial_opinion}
          callback={setVersion}
        />
      ),
    },
    {
      title: "上报国办",
      key: "isReported",
      width: 80,
      render: (record) => (
        <ReportSwitch
          messageId={record.id}
          defaultValue={record.is_reported}
          callback={setVersion}
        />
      ),
    },

    {
      title: "国办批示",
      key: "state_opinion",
      width: 80,
      render: (record) => (
        <OpinionSwitch
          messageId={record.id}
          field="state_opinion"
          defaultValue={record.state_opinion}
          callback={setVersion}
        />
      ),
    },
    {
      title: "扣分",
      key: "deduct_point",
      width: 100,
      render: (record) => (
        <DeductPointSelect
          messageId={record.id}
          defaultValue={record.deduct_point?.id}
          callback={setVersion}
        />
      ),
    },
    {
      title: "得分",
      dataIndex: "score",
      width: 60,
    },
  ];

  return (
    <div className={styles.receiveMessage}>
      <div className="table-toolbar">
        <div className="left"></div>
        <div className="right">
          <Space>
            <div>
              类型：
              <Select
                style={{ width: 60 }}
                loading={messageTypeLoading}
                onChange={(value) => setType(value)}
                allowClear
              >
                {types.results.map((t) => (
                  <Select.Option key={`type-${t.id}`} value={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div>
              单位类型：
              <DepartmentTypeSelect value={code} onChange={setCode} />
            </div>
            <div>
              单位：
              <DepartmentSelect
                value={department}
                onChange={setDepartment}
                code={code}
              />
            </div>
            <div>
              日期：
              <DatePicker.RangePicker
                allowClear
                disabledDate={(current) => current.isAfter(moment())}
                onChange={(value) => {
                  setStartDate(value[0].format("YYYY-MM-DD"));
                  setEndDate(value[1].format("YYYY-MM-DD"));
                }}
              />
            </div>
            <div>
              标题：
              <Input
                prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                style={{ width: 220 }}
                placeholder="搜索内容"
                allowClear
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>
            <ExportToTxt
              type={type}
              startDate={startDate}
              endDate={endDate}
              department={department}
              keyword={keyword}
              token={auth.token}
            />
          </Space>
        </div>
      </div>
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={{
          pageSize: pageSize,
          total: data.count,
        }}
        onChange={({ current, pageSize }) => {
          setPage(current);
          setPageSize(pageSize);
        }}
      />
    </div>
  );
}

export default Status4MessageTable;
